// @flow

import React from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import Text from '../Sections/Text'
import WebCaption from '../Captions/WebCaption'
import color from 'michelangelo/dist/Components/styles/color'

type BodyTitleProps = {
    title: string
}
const TitleContainer: ReactComponentStyled<{}> = styled.div`
  justify-self: center;
  background-color: ${color.white};
  max-width: 100%;
  padding: 16px 0px;
`
TitleContainer.displayName = 'TitleContainer'
function WebTitle ({ title }: BodyTitleProps) {
  return (
    <WebCaption>
      <TitleContainer>
        <Text text={title} size='1' align='left' fontColor='default' />
      </TitleContainer>
    </WebCaption>
  )
}

export default WebTitle
